import { useState, useCallback, useEffect } from "react";
import * as Controller from "../components/Controller/Controller";
import UI from "../components/UI";
import Text from "../libs/react-phaser-fiber/components/Text";
import usePhaser from "../libs/react-phaser-fiber/hooks/usePhaser";
import { SCALE } from "../utils/constants";

const OptionsScene = () => {
  const { game, scene } = usePhaser();
  const [selIndex, setSelIndex] = useState(0);
  const [subSelIndex, setSubSelIndex] = useState([0, 0, 0, 0]);
  const [options] = useState(["Music", "Sounds", "CRT Effect", "Language"]);
  const [submenu] = useState([
    ["On", "Off"], // Music
    ["On", "Off"], // Sounds
    ["On", "Off"], // CRT Effect
    ["Spanish", "English"], // Language
  ]);

  const keyDownHandler = useCallback(
    (event) => {
      if (Controller.isCancel(event.key)) {
        game.scene.start("SplashScreenScene");
      }
      if (Controller.isDown(event.key) && selIndex < options.length - 1) {
        setSelIndex((idx) => idx + 1);
      }
      if (Controller.isUp(event.key) && selIndex > 0) {
        setSelIndex((idx) => idx - 1);
      }
      if (Controller.isConfirm(event.key)) {
        const subSel = [...subSelIndex];
        subSel[selIndex] = (subSel[selIndex] + 1) % submenu[selIndex].length;
        setSubSelIndex(subSel);
      }
    },
    [game, selIndex, options, submenu, subSelIndex]
  );
  useEffect(() => {
    scene?.input.keyboard.addListener("keydown", keyDownHandler);
    return () =>
      scene?.input.keyboard.removeListener("keydown", keyDownHandler);
  }, [scene, keyDownHandler]);

  useEffect(() => console.log(), []);

  const MARGIN_LEFT = UI.tileToScreen(1);
  const LINE_HEIGHT = UI.tileToScreen(1);
  const MARGIN_TOP = UI.tileToScreen(4);
  const OPT_OFFSET = UI.tileToScreen(8);

  return (
    <>
      {options.map((label, idx) => (
        <Text
          key={label}
          alpha={selIndex === idx ? 1 : 0.5}
          args={[
            MARGIN_LEFT,
            LINE_HEIGHT * idx + MARGIN_TOP,
            label,
            {
              fontFamily: "Emulogic",
              fontSize: "8px",
              fill: "#aee0c8",
              fontWeight: "regular",
            },
          ]}
          addedToScene={(txt) => {
            txt.displayHeight = 10 * SCALE;
            txt.depth = 16;
            txt.name = "header_text";
            txt.setScale(SCALE);
            txt.setScrollFactor(0);
            txt.setShadow(-1, 1);
          }}
        />
      ))}
      {submenu.map((sm, idx) => {
        const label = sm[subSelIndex[idx]];
        return (
          <Text
            key={`sub_opt_${idx}`}
            alpha={selIndex === idx ? 1 : 0.5}
            text={label}
            args={[
              MARGIN_LEFT + OPT_OFFSET,
              LINE_HEIGHT * idx + MARGIN_TOP,
              label,
              {
                fontFamily: "Emulogic",
                fontSize: "8px",
                fill: "#aee0c8",
                fontWeight: "regular",
              },
            ]}
            addedToScene={(txt) => {
              txt.displayHeight = 10 * SCALE;
              txt.depth = 16;
              txt.name = "header_text";
              txt.setScale(SCALE);
              txt.setScrollFactor(0);
              txt.setShadow(-1, 1);
            }}
          />
        );
      })}
    </>
  );
};

export default OptionsScene;
